import { ValidateEmail, ValidateName, ValidateSecondName } from "./validators/indexValidator";

export default function SendTipAFriend(identifier) {
  if (!identifier) {
    var $infoPopup = $('#tipafriend-dialog');
    identifier = $infoPopup.data("product-id");
  }
  var valid = true;
  $("#tipafriendResult").removeClass("error");
  $("#tipafriendResult").removeClass("green");
  $("#tipafriendResult").html("");
  var Name = $("input.tbxTipsName:visible");
  var Email = $("input.tbxTipsEmail:visible");
  var FriendEmail = $("input.tbxTipsFriendEmail:visible");
  var SecondName = $("input.tbxTipsSecondName:visible");
  var validArr = [];
  validArr.push(ValidateName(Name, "#FirstNameRequiredTips"));
  validArr.push(ValidateSecondName(SecondName, "#SecondNameRequiredTips"));
  validArr.push(ValidateEmail(Email, "#revEmailTips", "#rfvEmailTips"));
  validArr.push(ValidateEmail(FriendEmail, "#revFriendEmail", "#rfvFriendEmail"));
  for (var i = 0; i < validArr.length; i++) {
    if (!validArr[i]) {
      valid = false;
      break;
    }
  }

  if (valid) {
    var obj = {};
    obj.Name = Name.val();
    obj.FriendName = SecondName.val();
    obj.FriendEmail = FriendEmail.val();
    obj.Email = Email.val();
    obj.ProductIdentifier = identifier;
    $.ajax({
      data: JSON.stringify(obj),
      async: false,
      contentType: "application/json",
      type: "POST",
      url: "/api/Product/SendTipAFriend",
      success: function (data) {
        if (data != null) {
          if (!data.IsSuccess) {
            $("#tipafriendResult").addClass("error");
          }
          else {
            $("#tipafriendResult").addClass("green");
            Name.val('');
            Email.val('');
            FriendEmail.val('');
            SecondName.val('');
          }
          $("#tipafriendResult").html(data.Message);
        }
      }
    });
  }
}